<template>
    <div class="i-calendar"  :class="{bordered}" :style="{width:width?width+'px':'auto',height:height?height+'px':'auto'}">
        <div class="month" v-for="(month, mIdx) in skelet(months)" :style="{width:width?width/months+'px':'auto'}">
            <div class="head">
                <i v-if="i_theme.controls" class="fal fa-chevron-double-left" @click="select({month:formalDate.month-1})" />
                <i v-if="i_theme.controls" class="fal fa-chevron-double-right" @click="select({month:formalDate.month+1})" />
                 {{month.name}}, {{month.year}}
                <i v-if="i_theme.controls" class="fal fa-chevron-double-left" @click="select({year:formalDate.year-1})" />
                <i v-if="i_theme.controls" class="fal fa-chevron-double-right" @click="select({year:formalDate.year+1})" />
            </div>
            <div class="weekNames">
                <div class="weekName" v-for='weekName in weekNames' :style="i_theme.weekStyle">
                    {{weekName}}
                </div>
            </div>
            <div class="dates" :style="{height:height?height-112+'px':'auto'}" >
                <div class="week" v-for="week in month.weeks">
                    <div v-for="day in week" 
                        :style="Object.assign({marginLeft: day == 1? ((100*(month.weekStart-1)/7)+'%') : 0},theme.dayStyle.normal, day === formalDate.day?theme.dayStyle.active:{})" 
                        v-if="day>0" 
                        :class="{firstWeek: day<8&&day>0, day:day>0, active: day === formalDate.day}"
                        @click="select({day})">{{day?day:' '}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { DateTime, Info } from "luxon";
import _ from "lodash";
export default {
    props: {
        size: { type: String, default: 's' },
        width:{ type: Number, default: 0},
        height:{ type: Number, default: 0},
        months:{ type: Number, default: 1},


        bordered: { type: Boolean, default: true },
	    theme: {
	        type: Object,
	        default () {
	            return {


	            }
	        }
	    }
    },
    name: 'i-calendar',
    methods: {
        select(date) {
            this.formalDate = this.formalDate.set(date)
        },
        skelet(months) {
            let self = this;
            return _.fill(Array(months), 'month').map((m ,i)=>{
                let date = self.formalDate.plus({month:i});
                let weekStart = date.set({ day: 1 }).weekday;
                let daysInMonth = date.daysInMonth;
                let matrix = _.fill(Array(daysInMonth + weekStart - 1), 1).map((a, idx) => {
                    return idx >= weekStart - 1 ? idx - weekStart + 2 : 0;
                });
                let weeks = _.chunk(matrix, 7);
                return {name:date.monthLong,year:date.year,weeks, weekStart, daysInMonth}
            });
        },
    },
    mounted() {
        console.log(this.$data)
    },
    computed: {
        i_theme() {
            return Object.assign({}, {
                controls: true,
            },this.theme);
        },
        weekStart() {
            return this.formalDate.set({ day: 1 }).weekday
        },
        i_size() {
            let { sizes, size } = this;
            return sizes[size] ? sizes[size] : sizes.s
        }
    },
    data() {
        return {
            sizes: {
                xs:{

                },
                s: {
                    cellPaddings: 8,
                    fontSize: 45
                }
            },
            monthsNames: Info.months(),
            weekNames: Info.weekdays('short'),
            formalDate: DateTime.local()
        }
    }
}
</script>
<style lang="css" scoped>
.i-calendar {
    user-select: none;
    padding:0 0 20px 0;
}

.dates {
    width: 100%;
    height: 100%;
}

.head {
    font-size: 32px;
    text-transform: uppercase;
}

.week {
    display: inline-block;
    width: 100%;
    height: 16.666666666666668%;
}

.weekName {
    text-align: center;
    text-transform: uppercase;
    padding: 16px 0;
}

.empty,
.day,
.weekName {
    width: 14.285714285714286%;
    height: 100%;
    display: inline-block;
    border-width: 1px;
}

.day {
    border-style: solid;
    border-color: transparent;
    vertical-align: top;
    text-align: center;
    border-bottom-color: grey;
    border-right-color: grey;
}

.day:hover {
    background: whitesmoke;
    cursor: pointer;
}

.day:nth-child(1) {
    border-left-color: grey;
}

.day.active:hover,
.active {
    background: lightblue;
}

.head .fal {
    font-size: 18px;
    height: 32px;
    height: 100%;
    vertical-align: top;
    padding: 7px;
    display: inline-block;
    width: 32px;
    text-align: center;
    border-radius: 100%;
}

.firstWeek.day {
    border-top-color: grey;
}

.head .fal:hover {
    cursor: pointer;
    background: whitesmoke;
}

.bordered .day,.bordered .dates, .bordered.i-calendar{
    border-left-color: transparent;
    border-top-color: transparent;
    border-bottom-color: transparent;
    border-right-color: transparent;
}

.month{
    height:100%;
    float:left;
}
</style>